import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag";
import router from "./router";

Vue.use(VueGtag, {
    config: {
      id: 'UA-74065518-2'
    }
  }, router
);
